// a library to wrap and simplify api calls
// import Api from './PhiApi'

export default class PhiLog {

    constructor(options) {
        this.phiRef = options


        // this.get = function* (that, userId, options) {
        //     let token = that.phiRef.getSession()
        //     options = options ? options : {}
        //     options.logType = (options && options.logType) ? '(' + options.logType.join(',') + ')' : null
        //     options.entityType = 1
        //     options.entityId = userId
        //     if (token) {
        //         let response = yield Api.getUserLog(options)
        //         if (response.ok && response.data && response.data.results) {
        //             let logs = response.data.results
        //             return logs
        //         }
        //         else {
        //             return { error: response.problem }
        //         }
        //     }
        //     return null
        // }

    }



}